/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as Communicator from "@ts3d-hoops/web-viewer";
import { GlobalState } from "common/global";
import CTurnTableOperator from "../extends/CTurnTableOperator";
import BaseOperator from "./base.operator";

export default class TurntableOperator extends BaseOperator {
    axis: Communicator.Axis;
    constructor(viewer: Communicator.IWebViewer, axis: Communicator.Axis) {
        super(viewer);
        this.Name = "rotateZ";
        this.axis = axis;
    }
    /**
     * Active
     */
    public Active() {
        if (this.Status === false) {
            this.Viewer.operatorManager.remove(
                Communicator.OperatorId.Navigate
            );
            this.Viewer.operatorManager.push(Communicator.OperatorId.Pan);
            this.Viewer.operatorManager.push(Communicator.OperatorId.Turntable);
            if (
                this.Viewer.operatorManager.getOperator(
                    Communicator.OperatorId.Select
                )
            ) {
                this.Viewer.operatorManager.push(
                    Communicator.OperatorId.Select
                );
            }
            const turnTableOperator = this.Viewer.operatorManager.getOperator(
                Communicator.OperatorId.Turntable
            );
            turnTableOperator.setRotationAxis(this.axis);
            turnTableOperator.setMapping(Communicator.Button.Left);
            if (turnTableOperator instanceof CTurnTableOperator) {
                turnTableOperator.initialize();
            }
            const panOperator = this.Viewer.operatorManager.getOperator(
                Communicator.OperatorId.Pan
            );
            panOperator.addMapping(
                Communicator.Button.Left,
                Communicator.KeyModifiers.Shift
            );
            panOperator.addMapping(Communicator.Button.Right);
            this.Viewer.operatorManager.push(Communicator.OperatorId.Zoom);
            this.Status = true;
            GlobalState.mapOperatorCursor.set(
                "rotateZ",
                'url("/assets/cursor/rotate.png"), default'
            );
            GlobalState.primaryOperator.set(this.Viewer, "rotateZ");
            super.SetCursor('url("/assets/cursor/rotate.png"), default');
        }
    }

    /**
     * InActive
     */
    public InActive() {
        if (this.Status === true) {
            const turnTableOperator = this.Viewer.operatorManager.getOperator(
                Communicator.OperatorId.Turntable
            );
            if (turnTableOperator instanceof CTurnTableOperator) {
                turnTableOperator.DeleteTargetPointMarker();
                turnTableOperator.unSetCallback();
            }
            super.ResetDefautOperators();
            this.Status = false;
            super.SetCursor("");
        }
    }

    public onKeyDownEvent(event: KeyboardEvent) {
        const turnTableOperator = this.Viewer.operatorManager.getOperator(
            Communicator.OperatorId.Turntable
        );
        if (turnTableOperator instanceof CTurnTableOperator) {
            turnTableOperator.rotateZByKeyPress(event);
        }
    }
    GetIdOperator(): number {
        return Communicator.OperatorId.Turntable;
    }
}
